(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mz-announcement"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-mz-ann-pause]');if(!button)return;const banner=button.closest('[data-mz-ann]');const paused=banner.dataset.paused!=='true';banner.dataset.paused=String(paused);button.setAttribute('aria-pressed',String(paused));button.querySelector('span').textContent=paused?'▷':'Ⅱ';});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
function loadMirzeliaRecommendations(root) {
  root.querySelectorAll('[data-recommendations-url]').forEach(element => {
    if (element.dataset.loaded) return;
    element.dataset.loaded = 'true';
    const load = async () => {
      try {
        const response = await fetch(element.dataset.recommendationsUrl);
        if (!response.ok) return;
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const result = document.querySelector('[data-recommendations-url]');
        if (result && result.textContent.trim()) element.innerHTML = result.innerHTML;
      } catch { element.hidden = true; }
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); } }, {rootMargin:'200px'});
      observer.observe(element);
    } else load();
  });
}
loadMirzeliaRecommendations(document);
document.addEventListener('shopify:section:load', () => loadMirzeliaRecommendations(document));

  } catch(e) { console.error(e); }
})();
})();
